import React, { useState, useRef } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './candidate-info-nav.css';
import ExperienceIcon from '../../../../assets/images/Ic_work position.png';
import EducationIcon from '../../../../assets/images/Ic_Education.png';
import CertificationsIcon from '../../../../assets/images/Ic_certificate.png';
import TrophyIcon from '../../../../assets/images/noun-trophy-1860077 1.png';
import TechnicalProficiencyIcon from '../../../../assets/images/Ic_Technical Proficiency.png';

const CandidateInfoNavBar = ({ setChildNavigation }) => {
  const [activeNav, setActiveNav] = useState('experience');
  const navContainerRef = useRef(null);
  const navRefs = {
    experience: useRef(null),
    education: useRef(null),
    certification: useRef(null),
    awards: useRef(null),
    'technical-proficiency': useRef(null),
  };

  const handleNavClick = (nav) => {
    setActiveNav(nav);
    setChildNavigation(nav);

    if (window.innerWidth <= 767 && navContainerRef.current) {
      const currentElement = navRefs[nav]?.current;
      if (currentElement) {
        const container = navContainerRef.current;
        const offsetLeft = currentElement.offsetLeft - container.offsetLeft;
        container.scrollTo({ left: offsetLeft, behavior: 'smooth' });
      }
    }
  };

  return (
    <Navbar bg="light" expand="lg" className="p-0">
      <Navbar.Collapse id="client-navbar-nav">
        <Nav className="mr-auto" ref={navContainerRef} id="client-navbar-nav">
          <Nav.Link ref={navRefs.experience} onClick={() => handleNavClick('experience')} className={`d-flex align-items-center ${activeNav === 'experience' ? 'active' : ''}`} >
            <img src={ExperienceIcon} alt="Experience" /> Experience
          </Nav.Link>
          <Nav.Link ref={navRefs.education} onClick={() => handleNavClick('education')} className={`d-flex align-items-center ${activeNav === 'education' ? 'active' : ''}`} >
            <img src={EducationIcon} alt="Education" /> Education
          </Nav.Link>
          <Nav.Link ref={navRefs.certification} onClick={() => handleNavClick('certification')} className={`d-flex align-items-center ${activeNav === 'certification' ? 'active' : ''}`} >
            <img src={CertificationsIcon} alt="Certifications" /> Certifications
          </Nav.Link>
          <Nav.Link ref={navRefs.awards} onClick={() => handleNavClick('awards')} className={`d-flex align-items-center ${activeNav === 'awards' ? 'active' : ''}`} >
            <img src={TrophyIcon} alt="Awards" /> Awards
          </Nav.Link>
          <Nav.Link ref={navRefs['technical-proficiency']} onClick={() => handleNavClick('technical-proficiency')} className={`d-flex align-items-center ${activeNav === 'technical-proficiency' ? 'active' : ''}`}>
            <img src={TechnicalProficiencyIcon} alt="Technical Proficiency" /> Technical Proficiency
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default CandidateInfoNavBar;